export default __webpack_public_path__ + "static/SSSpyView_screenshot-1@mob2x-c905278c3868bad59f2130e3f65e5688.webp";